var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.43188 10.4578H12.8599C13.6663 10.4578 14.2999 9.81605 14.2999 9.04835V3.00935C14.2999 2.24165 13.6663 1.59995 12.8599 1.59995H3.13988C2.33348 1.59995 1.69988 2.24165 1.69988 3.00935V9.04835C1.69988 9.81605 2.33348 10.4578 3.13988 10.4578H4.57988V13.3H4.58258L4.58438 13.2991L8.43278 10.4578H8.43188ZM5.11988 14.0227C4.92829 14.1639 4.68891 14.2242 4.45326 14.1907C4.21761 14.1573 4.00453 14.0326 3.85988 13.8436C3.74393 13.6908 3.68104 13.5043 3.68078 13.3126V11.3578H3.14078C1.84838 11.3578 0.800782 10.3237 0.800782 9.04835V3.00935C0.799882 1.73405 1.84748 0.699951 3.13988 0.699951H12.8599C14.1523 0.699951 15.1999 1.73405 15.1999 3.00935V9.04835C15.1999 10.3246 14.1523 11.3578 12.8599 11.3578H8.72888L5.11898 14.0227H5.11988Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.5f65d2346de0eab3bf8e4dc195d0f11b.svg";
export { ForwardRef as ReactComponent };